import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn } from 'typeorm';
import { MeasurementDataEntity } from './measurement-data-entity';
import { TrimCardStatusEnum } from '@project-management-system/shared-models';

@Entity('styles_entity')
export class StylesEntity {

    @PrimaryGeneratedColumn('increment', {
        name: 'id',
    })
    id: number


    @Column('varchar', {
        nullable: true,
        length: 300,
        name: 'drop_down'
    })
    dropDown: string;

    @Column('varchar', {
        nullable: true,
        length: 1000,
        name: 'tech_pack'
    })
    techPack: string;

    @Column('varchar', {
        nullable: true,
        length: 300,
        name: 'submit_date'
    })
    submitDate: string;

    @Column('varchar', {
        nullable: true,
        length: 300,
        name: 'season'
    })
    seasonData: string;

    @Column('varchar', {
        nullable: true,
        length: 300,
        name: 'style'
    })
    styleData: string;

    @Column('varchar', {
        nullable: true,
        length: 1000,
        name: 'style_description'
    })
    styleDescription: string;

    @Column('varchar', {
        nullable: true,
        length: 255,
        name: 'factory'
    })
    factory: string;

    @Column('varchar', {
        nullable: true,
        length: 255,
        name: 'approval_type'
    })
    approvalType: string;

    @Column('varchar', {
        nullable: true,
        length: 255,
        name: 'state_data'
    })
    stateData: string;

    @Column('varchar', {
        nullable: true,
        length: 255,
        name: 'factory_merchandiser_sign'
    })
    factoryMerchandiserSign: string;

    @Column('varchar', {
        nullable: true,
        length: 255,
        name: 'comments'
    })
    comments: string;

    @Column('varchar', {
        nullable: true,
        length: 255,
        name: 'approved_by'
    })
    approvedBy: string;

    @Column("boolean", {
        nullable: true,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;

    @Column('enum', {
        name: 'status',
        enum: TrimCardStatusEnum
    })
    status: TrimCardStatusEnum;

    @Column('varchar', {
        nullable: true,
        length: 300,
        name: 'pdf_file_path'
    })
    filePath: string;

    @Column('varchar', {
        nullable: true,
        length: 250,
        name: 'pdf_file_name'
    })
    fileName: string;

    @Column('varchar', {
        nullable: true,
        length: 250,
        name: 'pdf_original_name'
    })
    originalname: string;

    @Column('varchar', {
        nullable: true,
        length: 250,
        name: 'image_files'
    })
    imageFiles: string;
   
    @Column('varchar', {
        nullable: true,
        length: 250,
        name: 'image_original_name'
    })
    imageOriginalName: string;


    @OneToMany(type => MeasurementDataEntity, measurement => measurement.styles, { cascade: true })
    measurement: MeasurementDataEntity[]

}